export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10538.d6079074.jpg";